<div class="select-form">
    <label class="col-form-label" ref="labelForm" v-if="label" :for="id">{{ label }} <span class="required" v-if="required">(*)</span></label>
    <select class="form-select" v-model="value" :id="id" :disabled="disabled" >
        <option value="" disabled selected>{{placeholder}}</option>
        <option :hidden="option.style?.hidden" :value="option.value" v-for="(option) in options" :key="option.key" @click="chooseOption(option.value)" :style="option.style">{{
                option.name ?? option.value
            }}
        </option>
    </select>
    <div class="error-text" v-if="error" :style="{left: distanceWithLabel}">{{error}}</div>
</div>
